import React, { useMemo } from 'react';
import { Column, Columns } from '../../../../styled/Columns/wrappers';
import Distance from '../../../../styled/Distance';
import Text from '../../../../styled/Text';
import { IUiDocument } from '../providers/useParseProduct';
import { useTrackGenericEvent } from '../../../../hooks/tracking/useTrackingEvents';
import Link from '../../../../Router/Link';

interface IDocuments {
  items: IUiDocument[];
}

const Documents = ({ items }: IDocuments) => {
  return (
    <>
      {items.map((document) => (
        <React.Fragment key={document.url}>
          <Item {...document} />
          <Distance line size="3" />
        </React.Fragment>
      ))}
    </>
  );
};

export default Documents;

const Item = ({ url, thumbnailUrl, type, title }: IUiDocument) => {
  const trackingEvent = useMemo(
    () => ({ event: `product_document_download`, value: type }),
    [type],
  );
  const trackDownload = useTrackGenericEvent(trackingEvent);

  return (
    <Link
      Component={Columns}
      as="a"
      href={url}
      data-reload
      className="valign-middle
      space-3"
      onBeforeNavigate={trackDownload}
      target="_blank"
      rel="noopener noreferrer">
      <Column as="span">
        <img src={thumbnailUrl} alt={type} />
      </Column>
      <Column as="span" className="grow">
        <strong>{title}</strong>
        <Text size="small" tone="ghost">
          {type}
        </Text>
      </Column>
    </Link>
  );
};
